import React from "react";
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import SubPage from 'components/pages/users/sub-pages';


const UserRoute = ({ user, history, canCreateUsers = false, canAssignUserGroups = false, canManageUserGroups = false }) => {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }/logs` } >
                <SubPage.Logs
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }/logs/page/:pageNum` } exact>
                <SubPage.Logs
                    user={ user }
                    history={ history } />
            </Route>

            <Route path={ `${ path }` }>
                <SubPage.OverView
                    user={ user }
                    history={ history }
                    canCreateUsers={ canCreateUsers }
                    canAssignUserGroups={ canAssignUserGroups }
                    canManageUserGroups={ canManageUserGroups } />
            </Route>
        </Switch>
    );
};

export default UserRoute;
